import React from 'react';
import { Helmet } from 'react-helmet';
import { motion } from 'framer-motion';
import heroImage from '../assets/hero-elaine-profissional.webp';

const temas = [
  'Saúde emocional',
  'Relacionamentos',
  'Carreira e desenvolvimento profissional',
];

export default function Hero() {
  return (
    <>
      {/* Mesmos valores do public/index.html (página inicial) */}
      <Helmet>
        <title>Psicóloga Online Elaine Rampazzo | Terapia e Carreira</title>
        <meta
          name="description"
          content="Psicóloga online com mais de 15 anos de experiência. Terapia para adolescentes, adultos e idosos: ansiedade, depressão, relacionamentos, autoestima e carreira."
        />
        <link rel="canonical" href="https://www.elaineterapia.com.br/" />
        <meta property="og:title" content="Psicóloga Online Elaine Rampazzo | Terapia e Carreira" />
        <meta
          property="og:description"
          content="Terapia online para adolescentes, adultos e idosos, com acolhimento diante dos desafios de cada momento."
        />
        <meta property="og:image" content="https://www.elaineterapia.com.br/og-image.jpg" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.elaineterapia.com.br/" />
        <meta name="twitter:title" content="Psicóloga Online Elaine Rampazzo | Terapia e Carreira" />
        <meta
          name="twitter:description"
          content="Terapia online para adolescentes, adultos e idosos, com acolhimento diante dos desafios de cada momento."
        />
        <meta name="twitter:image" content="https://www.elaineterapia.com.br/og-image.jpg" />
      </Helmet>

      <section
        id="hero"
        className="position-relative overflow-hidden"
        style={{
          minHeight: '100svh',
          paddingTop: '110px',
          background: 'linear-gradient(to bottom right, #f4f7f7, #e9f1f0)',
        }}
      >
        <div className="container py-5 position-relative">
          <div className="row align-items-center g-5">

            {/* TEXTO */}
            <div className="col-lg-6 text-center text-lg-start">

              {/* Visualmente é o título, mas o H1 (usado pelo Google) é a frase abaixo */}
              <motion.p
                className="fw-bold mb-3"
                style={{
                  color: '#1f4e5a',
                  fontSize: 'clamp(2rem, 3.2vw, 2.8rem)',
                  lineHeight: '1.2',
                }}
                initial={{ opacity: 0, y: -30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
              >
                Seja bem-vindo(a)
              </motion.p>

              <motion.h1
                className="mb-3"
                style={{
                  color: '#1f4e5a',
                  fontSize: 'clamp(1.3rem, 2vw, 1.6rem)',
                  fontWeight: '500',
                  lineHeight: '1.3',
                }}
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2, duration: 0.8 }}
              >
                Terapia online para diferentes fases da vida
              </motion.h1>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4, duration: 1 }}
              >
                <p
                  className="mb-4"
                  style={{
                    fontSize: '1.15rem',
                    color: '#3d4a4d',
                    lineHeight: '1.7',
                  }}
                >
                  Atendimento psicológico para adolescentes, adultos e idosos, com acolhimento
                  diante dos desafios de cada momento.
                </p>

                <div className="d-flex flex-wrap gap-2 justify-content-center justify-content-lg-start mb-4">
                  {temas.map((tema) => (
                    <span key={tema} className="tag-tema">{tema}</span>
                  ))}
                </div>

                <div className="d-flex justify-content-center justify-content-lg-start">
                  <motion.a
                    href="https://wa.me/5511962382055"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-cta d-none d-md-flex align-items-center justify-content-center gap-2 px-4 py-3 shadow-lg"
                    style={{
                      fontSize: '1.1rem',
                      minHeight: '58px',
                    }}
                    whileHover={{ scale: 1.03 }}
                    whileTap={{ scale: 0.97 }}
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.8, duration: 0.8 }}
                  >
                    <i
                      className="bi bi-whatsapp"
                      style={{
                        fontSize: '1.4rem',
                        lineHeight: 1,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    />
                    <span>Agendar uma conversa</span>
                  </motion.a>
                </div>

              </motion.div>
            </div>

            {/* FOTO */}
            <div className="col-lg-6 text-center">
              <motion.img
                src={heroImage}
                alt="Psicóloga Elaine Rampazzo"
                fetchPriority="high"
                className="img-fluid"
                style={{
                  maxHeight: '520px',
                  maxWidth: '400px',
                  width: '100%',
                  objectFit: 'contain',
                  borderRadius: '20px',
                  boxShadow: '0 12px 30px rgba(0,0,0,0.08)',
                  backgroundColor: '#fff',
                  padding: '8px',
                }}
                initial={{ opacity: 0, x: 40 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 1 }}
              />
            </div>

          </div>
        </div>
      </section>

      {/* BOTÃO FIXO MOBILE */}
      <div
        className="d-md-none"
        style={{
          position: 'fixed',
          bottom: '15px',
          left: '50%',
          transform: 'translateX(-50%)',
          zIndex: 9999,
          width: '90%',
        }}
      >
        <a
          href="https://wa.me/5511962382055"
          target="_blank"
          rel="noopener noreferrer"
          className="btn-cta w-100 py-3 shadow-lg d-flex justify-content-center align-items-center gap-2"
          style={{
            fontSize: '1.1rem',
            minHeight: '58px',
          }}
        >
          <i
            className="bi bi-whatsapp"
            style={{
              fontSize: '1.4rem',
              lineHeight: 1,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          />
          <span>Agendar uma conversa</span>
        </a>
      </div>
    </>
  );
}
